"use strict";

/**
 * Actions that modify the URL.
 */
var LocationActions = {

  /**
   * Indicates a new location is being pushed to the history stack.
   */
  PUSH: "push",

  /**
   * Indicates the current location should be replaced.
   */
  REPLACE: "replace",

  /**
   * Indicates the most recent entry should be removed from the history stack.
   */
  POP: "pop"

};

module.exports = LocationActions;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/lib/actions/LocationActions.js
 ** module id = 46
 ** module chunks = 0
 **/